import styled from '@emotion/styled';
import { Banner } from '@hotjar/hotsauce';

import { useStickyNotification } from '@hotjar/navigation/src/hooks/useStickyNotification';
import type { StickyBannerProps } from '@hotjar/navigation/src/hooks/useStickyNotification';

import { useNavigation } from '@hotjar/navigation/src/hooks/useNavigation';
import { useEffect } from 'react';

const Container = styled.div``;

export const StickyBanners = (): JSX.Element | null => {
  const { notifications, hide } = useStickyNotification();
  const { setExtraBannersCount } = useNavigation();

  const handleDismiss = (
    notificationInstance: string,
    notificationOnDismiss: StickyBannerProps['onDismiss'],
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    hide(notificationInstance);
    notificationOnDismiss?.(event);
  };

  const notificationsArray = Object.keys(notifications).map((n) => {
    return {
      ...notifications[n],
      instance: n,
    };
  });

  useEffect(() => {
    setExtraBannersCount(notificationsArray.length);
  }, [notificationsArray.length, setExtraBannersCount]);

  return notificationsArray.length ? (
    <Container data-testid="sticky-banners">
      {notificationsArray.map((notification) => {
        return (
          <Banner
            key={notification.instance}
            kind={notification.kind}
            actionText={notification.actionText}
            actionHref={notification.actionHref}
            onAction={notification.onAction}
            isDismissible={notification.isDismissible}
            actionProps={notification.actionProps}
            onDismiss={
              notification.isDismissible
                ? (event) => handleDismiss(notification.instance, notification.onDismiss, event)
                : undefined
            }
          >
            {notification.text as string}
          </Banner>
        );
      })}
    </Container>
  ) : null;
};
